import { TOGGLE_OWNERSHIP_SECTION } from './constants'

export function toggleOwnershipSection(module, id, blockKey, customData) {
    return {
        type: TOGGLE_OWNERSHIP_SECTION,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
